import {userVideoSeen} from "@/core/utils/user";

export function courseProgression(user, videos) {
  return videos.reduce((total, video) => total + (userVideoSeen(user, video) ? 1 : 0), 0);
}
